import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { NavigationService } from '../../../shared/services/navigation/navigation.service';
import { CommonService } from '../../../vass-core/services/common.service';

@Injectable()
export class LayoutService {
  constructor(
    private commonService: CommonService,
    private navigationService: NavigationService,
  ) {}

  recoverUserData() {
    return forkJoin(this.getMortgageData(), this.getMortgageDataEconomic()).pipe(
      map((res) => Object.assign(res[0], res[1])),
      catchError((error) => {
        // this.navigationService.redirectToError();
        throw error;
      }),
    );
  }

  getMortgageData(): Observable<any> {
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}/mortgage/data`;
    return this.commonService.getVerb(url);
  }

  getMortgageDataEconomic() {
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}/mortgage/data/economic`;
    return this.commonService.getVerb(url);
  }
}
